import { _ } from "@bazo/js-translator";
import React from "react";

const EmptyState = () => {
	return <div className="empty-state">{_("emptyState.text")}</div>;
};

export default EmptyState;
